import { Link } from "react-router-dom";
import styled from "styled-components";

export const TileLink = styled(Link)`
  text-decoration: none;
`;
